import React from "react";
import { statusInfo, TONE_CLASS } from "./trackApi";

export default function TrackStatusChip({ status }) {
  const info = statusInfo(status);
  return (
    <span
      data-testid="track-status"
      className={`inline-block rounded-full px-3 py-1 text-xs font-bold whitespace-nowrap ${TONE_CLASS[info.tone]}`}
    >
      {info.label}
    </span>
  );
}
